/** @jsx jsx */
import { Box, Flex, Heading, Paragraph, Tag } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { getJobRequestClientInfo, IJobRequest } from "@/data/job-requests";
import { formatMultipleLocationsWithCounter } from "@/data/locations";
import { JobRequestClientAvatar } from "@/views/JobRequests";
import { router } from "@/views/router";

interface SimilarJobTileProps {
  jobRequest: Partial<IJobRequest>;
}

export const SimilarJobTile: FC<SimilarJobTileProps> = ({ jobRequest }) => {
  const { t } = useTranslation(["public", "session"]);

  const clientInfo = getJobRequestClientInfo(jobRequest);

  return (
    <ResponsiveCard as={Link} to={router.get("job-requests.detail", { jobRequestId: jobRequest.id }).path}>
      <Flex flexDirection="column" gap="md">
        <Flex flexDirection="column" gap="xs">
          <JobRequestClientAvatar size="lg" jobRequest={jobRequest} />
          <Flex flexDirection="column" gap="xxs">
            <Heading
              size="h-xs"
              sx={{
                lineClamp: 2,
                WebkitLineClamp: 2,
                display: "-webkit-box",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitBoxOrient: "vertical",
                minHeight: 40,
              }}>
              {jobRequest.title}
            </Heading>
            <Flex flexDirection="column">
              <Paragraph size="p-md" color="n700">
                {clientInfo.name}
              </Paragraph>
              <Paragraph size="p-md" color="n700">
                {formatMultipleLocationsWithCounter(t, jobRequest.locations)}
              </Paragraph>
            </Flex>
          </Flex>
        </Flex>
        <Box>
          <Tag>
            {t(
              `session:JOB_REQUESTS.DETAIL.REMOTENESS.${
                jobRequest.remoteness === 100
                  ? "FULLY_REMOTE_TAG"
                  : jobRequest.remoteness === 0
                  ? "ON_SITE_TAG"
                  : "PARTIAL_TAG"
              }`,
            )}
          </Tag>
        </Box>
      </Flex>
    </ResponsiveCard>
  );
};
